import React, { useMemo, useContext } from "react";

import Loader from "components/Loader";
import useGet from "hooks/useGet";

const IssueKindsContext = React.createContext();

function IssueKindsProvider({ children }) {
  const { is_loading, data, refetch } = useGet({
    path: "/issue_kinds",
    query: ["issue_kinds"],
    context: "ui_index",
    search: {
      per_page: 100,
      sort: "position__asc",
    },
    options: {
      refetchOnWindowFocus: true,
    },
  });

  const issue_kind_options = data?.map(({ id, name }) => ({
    label: name,
    value: id,
  }));

  const value = useMemo(() => {
    return {
      data,
      issue_kind_options,
      refetch,
    };
    // eslint-disable-next-line
  }, [is_loading, issue_kind_options, data]);

  if (is_loading) {
    return <Loader />;
  }

  return (
    <IssueKindsContext.Provider value={value}>
      {children}
    </IssueKindsContext.Provider>
  );
}

const useIssueKinds = () => useContext(IssueKindsContext);
export { useIssueKinds };
export default IssueKindsProvider;
